export enum PermissionActionType {
  // Manage Products
  PRODUCT_MAINTENANCE = "product_maintenance",
  INSTRUCTION_MAINTENANCE = "instruction_maintenance",
  EQUIVALENT_MAINTENANCE = "equivalent_maintenance",

  // Accounting
  ACCOUNTING_MAINTENANCE = "accounting_maintenance",
  ACCOUNTING_MANAGER = "accounting_manager",
  ACCOUNTING_VIEW = "accounting_view",

  // GL Transactions
  GL_TRANSACTION_MAINTENANCE = "gl_transaction_maintenance",
  GL_TRANSACTION_VIEW = "gl_transaction_view",

  // System Admin
  ROLE_MAINTENANCE = "role_maintenance",
  USER_MAINTENANCE = "user_maintenance",

  //Customer Maintenance
  CUSTOMER_VIEW = "customer_view",
  CUSTOMER_MAINTENANCE = "customer_maintenance",

  // Test Templates
  TEST_TEMPLATE_MAINTENANCE = "test_template_maintenance",
  TEST_TEMPLATE_VIEW = "test_template_view",

  // Test Results
  TEST_RESULT_OVERRIDE = "test_result_override",

  // Warehouse
  WAREHOUSES_MAINTENANCE = "warehouse_area_maintenance",
  WAREHOUSES_VIEW = "warehouse_area_view",

  // Vendor
  VENDOR_LOCATION_ASSOCIATION = "vendor_location_association",
  VENDOR_MAINTENANCE = "vendor_maintenance",
  VENDOR_PRODUCT_MAINTENANCE = "vendor_product_maintenance",
  VENDOR_VIEW = "vendor_view",

  // Purchase Order
  PURCHASE_ORDER_CREATION = "purchase_order_creation",

  // Change Log
  CHANGE_LOG_VIEW = "change_log_view",

  // Tablet View Access
  WAREHOUSE_TABLET_ONLY = "warehouse_tablet_only",

  // Warehouse Receiving
  WAREHOUSE_RECEIVING_VIEW = "warehouse_receiving_view",
  WAREHOUSE_RECEIVING_MAINTENANCE = "warehouse_receiving_maintenance",
  LOCATION_OVERRIDE = "location_override",

  // Cost Breakdown
  COST_BREAKDOWN_VIEW = "cost_breakdown_view",
  COST_BREAKDOWN_MAINTENANCE = "cost_breakdown_maintenance",

  // Cost Maintenance
  COST_MAINTENANCE = "cost_maintenance",

  // Inventory
  INVENTORY_VIEW = "inventory_view",
  INVENTORY_MAINTENANCE = "inventory_maintenance",

  // Pricing
  PRICING_VIEW = "pricing_view",
  PRICING_MANAGER = "pricing_manager",
  PRICING_MAINTENANCE = "pricing_maintenance",
}

// if user contains one of that permission, they will see admin menu
export const AdminSectionPermissionList = [
  PermissionActionType.PRODUCT_MAINTENANCE,
  PermissionActionType.INSTRUCTION_MAINTENANCE,
  PermissionActionType.EQUIVALENT_MAINTENANCE,

  PermissionActionType.ROLE_MAINTENANCE,
  PermissionActionType.USER_MAINTENANCE,

  PermissionActionType.ACCOUNTING_MAINTENANCE,
  PermissionActionType.ACCOUNTING_MANAGER,
  PermissionActionType.ACCOUNTING_VIEW,

  PermissionActionType.GL_TRANSACTION_MAINTENANCE,
  PermissionActionType.GL_TRANSACTION_VIEW,

  PermissionActionType.WAREHOUSES_MAINTENANCE,
  PermissionActionType.WAREHOUSES_VIEW,

  PermissionActionType.TEST_TEMPLATE_VIEW,

  PermissionActionType.VENDOR_VIEW,
  PermissionActionType.VENDOR_MAINTENANCE,

  PermissionActionType.CHANGE_LOG_VIEW,
]

export enum PermissionRole {
  ADMIN = "Administrator",
  ACCOUNTING = "Accounting",
  VENDOR = "Vendor",
}
